export enum ValidacaoImportacaoXmlNFeEntradaEnum {
  UploadArquivo = 1,
  SchemaNFe = 2,
  Duplicata = 3,
  Destinatario = 4,
  ProtocoloAutorizacao = 5,
  AmbienteEmissao = 6,
}
